import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { KeyStringFilterInput } from 'app/api/common.api.types';
import {
  AccountingRemoveAll,
  AccountingRequested,
} from 'app/main/accounting/accounting.actions';
import { AnalyticsActions } from 'app/main/analytics/actions';
import { BalanceRequested } from 'app/main/balance/balance.actions';
import {
  ChartsExpensesReset,
  ChartsRevenueReset,
} from 'app/main/charts/charts.actions';
import { CubeRemoveAll, CubeRequested } from 'app/main/cube/cube.actions';
import { JournalRequested } from 'app/main/journal/journal.actions';
import { PlanRequested } from 'app/main/plan/plan.actions';
import { RuleRequested } from 'app/main/rule/rule.actions';
import { AppState } from 'app/reducers';
import { filter, map, mergeMap, withLatestFrom } from 'rxjs/operators';

import { CompaniesUIActions, CompanyActions } from '../actions';
import { CompaniesUISelectors } from '../selectors';
import {
  PayrollActions,
  PayrollExtraActions,
  PayrollRuleActions,
} from 'app/main/payroll/actions';
import { PlActions } from 'app/main/p&l/actions';

@Injectable()
export class CompaniesUIEffects {
  setCurrentCompany$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CompaniesUIActions.setCurrentCompany),
      withLatestFrom(
        this.store.select(CompaniesUISelectors.selectCurrentCompanyChanged)
      ),
      filter(([_, changed]) => changed),
      mergeMap(([{ companyId }, _]) => [
        CompanyActions.companyRequested({ companyId }),
        CompaniesUIActions.resetCurrentPeriod(),
        AnalyticsActions.analyticsRequested({ query: { companyId } }),
        new BalanceRequested({ companyId }),
        new JournalRequested({ companyId }),
        new PlanRequested({ companyId }),
        new RuleRequested({ companyId }),
        // PayrollActions.payrollRequested({ query: { companyId } }),
        PayrollExtraActions.payrollExtraRequested({ query: { companyId } }),
        PayrollRuleActions.payrollRuleRequested({ query: { companyId } }),
        PlActions.plLoadRequested({}),
      ])
    )
  );

  setCurrentPeriod$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CompaniesUIActions.setCurrentPeriod),
      withLatestFrom(
        this.store.select(CompaniesUISelectors.selectCurrentCompanyId),
        this.store.select(CompaniesUISelectors.selectCurrentPeriodChanged)
      ),
      filter(([{ period }, companyId, changed]) => changed),
      mergeMap(([{ period }, companyId]) => [
        new AccountingRequested({
          companyId,
          key: period.keyStringFilterInput,
        }),
        PayrollActions.payrollRequested({
          query: {
            companyId,
            key: period.keyStringFilterInput,
          },
        }),
        new CubeRequested({
          companyId,
          key: period.keyStringFilterInput,
        }),
        new ChartsExpensesReset(),
        new ChartsRevenueReset(),
      ])
    )
  );

  resetCurrentPeriod$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CompaniesUIActions.resetCurrentPeriod),
      mergeMap(() => [
        new AccountingRemoveAll(),
        PayrollActions.payrollRemoveAll(),
        new CubeRemoveAll(),
        new ChartsExpensesReset(),
        new ChartsRevenueReset(),
      ])
    )
  );

  constructor(private actions$: Actions, private store: Store<AppState>) {}
}
